import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { CheckMarkIcon, CrossCheckMarkIcon } from "../../../icons";
import { Modal } from "../../../modal";

interface Props {
  open: boolean;
  onClose(): void;
}

export function InformationModal({ open, onClose }: Props) {
  return (
    <Modal
      maxWidth="sm"
      title="Information disclosure"
      open={open}
      onClose={onClose}>
      <Box mb={4}>
        <Grid spacing={3} container>
          <Grid item sm={12}>
            <Typography variant="h5" color="info.main">
              What we do
            </Typography>
          </Grid>
          <Grid item xs={12} sm={1}>
            <CheckMarkIcon />
          </Grid>
          <Grid item xs={12} sm={11}>
            <Typography
              variant="h5"
              sx={(theme) => ({
                borderBottom: `1px solid ${theme.palette.grey[300]}`,
              })}>
              We use a third party to access consumer reports, including
              insurance loss history reports.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={1}>
            <CheckMarkIcon />
          </Grid>
          <Grid item xs={12} sm={11}>
            <Typography
              variant="h5"
              sx={(theme) => ({
                borderBottom: `1px solid ${theme.palette.grey[300]}`,
              })}>
              These reports may be reviewed in conjunction with this application
              to help determine your eligibility for insurance and the price you
              are charged. We may also use these reports to determine price at
              renewal.
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Grid spacing={3} container>
        <Grid item sm={12}>
          <Typography variant="h5" color="info.main">
            What we don&apos;t do
          </Typography>
        </Grid>
        <Grid item xs={12} sm={1}>
          <CrossCheckMarkIcon />
        </Grid>
        <Grid item xs={12} sm={11}>
          <Typography
            variant="h5"
            sx={(theme) => ({
              borderBottom: `1px solid ${theme.palette.grey[300]}`,
            })}>
            We do not impact your credit rating in any way by accessing your
            credit-based insurance score.
          </Typography>
        </Grid>
        <Grid item xs={12} sm={1}>
          <CrossCheckMarkIcon />
        </Grid>
        <Grid item xs={12} sm={11}>
          <Typography variant="h5">
            We do not sell or share your insurance score.
          </Typography>
        </Grid>
      </Grid>
    </Modal>
  );
}
